// VAPTServicesPage.js
import React from 'react';
import styles from './VAPTServicesPage.module.css';

const VAPTServicesPage = () => {
  return (
    <div className={styles.vaptServicesPage}>
      {/* Main Content Section */}
      <section className={styles.mainSection}>
        <div className={styles.container}>
          <div className={styles.contentGrid}>
            {/* Left Content */}
            <div className={styles.leftContent}>
              <h1 className={styles.pageTitle}>
                VAPT Services (Vulnerability Assessment & Penetration Testing)
              </h1>
              <p className={styles.pageDescription}>
                At Virtual IP, our Vulnerability Assessment and Penetration Testing 
                (VAPT) services offer a proactive and offensive security approach to 
                uncover and address weaknesses before malicious actors can 
                exploit them. By combining automated scans with manual 
                penetration testing, we provide a 360-degree view of your 
                organization's security posture and actionable steps to strengthen it.
              </p>
            </div>

            {/* Right Visual - placeholder for now */}
            <div className={styles.rightVisual}>
              <div className={styles.heroBackground}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Advanced Vulnerability Scanning Section */}
      <section className={styles.scanningSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Advanced Vulnerability Scanning
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                Virtual IP uses cutting-edge scanning tools to identify security flaws 
                across your entire IT ecosystem—covering web applications, 
                servers, APIs, databases, and network devices. Our approach 
                combines automation with expert manual verification to ensure 
                even subtle vulnerabilities don't go unnoticed.
              </p>
            </div>
            <div className={styles.sectionVisual}>
              <div className={styles.vulnerabilityScanningIllustration}>
                <div className={styles.isometricNetwork}>
                  <div className={styles.centerPlatform}>
                    <div className={styles.platformBase}></div>
                    <div className={styles.securityShield}></div>
                    <div className={styles.scanningRings}>
                      <div className={styles.ring1}></div>
                      <div className={styles.ring2}></div>
                      <div className={styles.ring3}></div>
                    </div>
                  </div>
                  <div className={styles.networkNodes}>
                    <div className={styles.node1}>
                      <div className={styles.nodeBase}></div>
                      <div className={styles.nodeStack}></div>
                    </div>
                    <div className={styles.node2}>
                      <div className={styles.nodeBase}></div>
                      <div className={styles.nodeStack}></div>
                    </div>
                    <div className={styles.node3}>
                      <div className={styles.nodeBase}></div>
                      <div className={styles.nodeStack}></div>
                    </div>
                    <div className={styles.node4}>
                      <div className={styles.nodeBase}></div>
                      <div className={styles.nodeStack}></div>
                    </div>
                    <div className={styles.node5}>
                      <div className={styles.nodeBase}></div>
                      <div className={styles.nodeStack}></div>
                    </div>
                  </div>
                  <div className={styles.connectionLines}>
                    <div className={styles.connectionLine}></div>
                    <div className={styles.connectionLine}></div>
                    <div className={styles.connectionLine}></div>
                    <div className={styles.connectionLine}></div>
                    <div className={styles.connectionLine}></div>
                  </div>
                  <div className={styles.lockIcon}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Real-World Penetration Testing Section */}
      <section className={styles.penetrationSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionVisual}>
              <div className={styles.penetrationTestingIllustration}>
                <div className={styles.penetrationBackground}>
                  <div className={styles.securityInterface}>
                    <div className={styles.mainScreen}>
                      <div className={styles.screenFrame}></div>
                      <div className={styles.screenContent}>
                        <div className={styles.securityShieldIcon}>
                          <div className={styles.shieldBase}></div>
                          <div className={styles.shieldCheck}>✓</div>
                        </div>
                        <div className={styles.interfaceElements}>
                          <div className={styles.statusDots}>
                            <div className={styles.dot}></div>
                            <div className={styles.dot}></div>
                            <div className={styles.dot}></div>
                          </div>
                          <div className={styles.progressBars}>
                            <div className={styles.progressBar1}></div>
                            <div className={styles.progressBar2}></div>
                            <div className={styles.progressBar3}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.sideScreens}>
                      <div className={styles.sideScreen1}></div>
                      <div className={styles.sideScreen2}></div>
                    </div>
                  </div>
                  <div className={styles.floatingElements}>
                    <div className={styles.floatingDot1}></div>
                    <div className={styles.floatingDot2}></div>
                    <div className={styles.floatingDot3}></div>
                    <div className={styles.floatingDot4}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Real-World Penetration Testing
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                Our certified ethical hackers simulate real-world attacks to test your 
                defenses under pressure. These penetration tests mimic 
                techniques used by cybercriminals to exploit vulnerabilities, helping 
                you understand your exposure to threats like privilege escalation, 
                SQL injection, cross-site scripting, and more.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Actionable Reporting Section */}
      <section className={styles.reportingSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Actionable Reporting & Risk Prioritization
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                After the assessment, Virtual IP provides a comprehensive report 
                highlighting each identified vulnerability, its exploitability, potential 
                impact, and recommended remediation steps. We help you 
                prioritize fixes based on threat severity and business impact, so 
                your team can act quickly and efficiently.
              </p>
            </div>
            <div className={styles.sectionVisual}>
              <div className={styles.reportingIllustration}>
                <div className={styles.reportingBackground}>
                  <div className={styles.reportingPerson}>
                    <div className={styles.personBody}></div>
                    <div className={styles.personHead}></div>
                    <div className={styles.personArm}></div>
                  </div>
                  <div className={styles.reportingElements}>
                    <div className={styles.reportDocument}>
                      <div className={styles.documentLines}>
                        <div className={styles.documentLine}></div>
                        <div className={styles.documentLine}></div>
                        <div className={styles.documentLine}></div>
                      </div>
                    </div>
                    <div className={styles.chartElement}></div>
                  </div>
                  <div className={styles.floatingLeaves}>
                    <div className={styles.leaf1}></div>
                    <div className={styles.leaf2}></div>
                    <div className={styles.leaf3}></div>
                    <div className={styles.leaf4}></div>
                  </div>
                  <div className={styles.backgroundShapes}>
                    <div className={styles.shape1}></div>
                    <div className={styles.shape2}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Remediation Guidance Section */}
      <section className={styles.remediationSection}>
        <div className={styles.container}>
          <div className={styles.sectionGrid}>
            <div className={styles.sectionVisual}>
              <div className={styles.remediationIllustration}>
                <div className={styles.remediationBackground}>
                  <div className={styles.teamCollaboration}>
                    <div className={styles.teamMember1}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                    <div className={styles.teamMember2}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                    <div className={styles.teamMember3}>
                      <div className={styles.memberBody}></div>
                      <div className={styles.memberHead}></div>
                    </div>
                    <div className={styles.collaborationTable}>
                      <div className={styles.tableTop}></div>
                      <div className={styles.tableScreen}></div>
                    </div>
                  </div>
                  <div className={styles.communicationBubbles}>
                    <div className={styles.bubble1}>
                      <div className={styles.bubbleContent}>...</div>
                    </div>
                    <div className={styles.bubble2}>
                      <div className={styles.bubbleContent}>...</div>
                    </div>
                    <div className={styles.bubble3}>
                      <div className={styles.bubbleContent}>...</div>
                    </div>
                  </div>
                  <div className={styles.backgroundElements}>
                    <div className={styles.bgElement1}></div>
                    <div className={styles.bgElement2}></div>
                    <div className={styles.bgElement3}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>
                Expert Remediation Guidance
              </h2>
              <div className={styles.titleUnderline}></div>
              <p className={styles.sectionDescription}>
                We go beyond just reporting issues—Virtual IP partners with your 
                team to remediate the vulnerabilities effectively. From patch 
                deployment and secure configurations to long-term security 
                hardening, we ensure your systems are fortified against future 
                attacks.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VAPTServicesPage;